var React = require('react');

function Unlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19,8A5,5,0,0,0,9,8v3H8a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H11V8a3,3,0,0,1,6,0Z","transform":"translate(-6 -3)","fill":"currentColor"}));
}

Unlock.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20"};

module.exports = Unlock;

Unlock.default = Unlock;
